import { FC } from 'react';

import { useDocumentSourceUrl } from '../hooks/use-document-source-url';

interface SourceRef {
  documentPackageId?: string | null;
  blobId?: string | null;
}

const SourceSubscription: FC<{ packageId: string; blobId: string }> = ({ packageId, blobId }) => {
  useDocumentSourceUrl(packageId, blobId);
  return null;
};

const uniqueSources = (chunks: SourceRef[]) => {
  const seen = new Map<string, { packageId: string; blobId: string }>();
  for (const { documentPackageId, blobId } of chunks) {
    if (!documentPackageId || !blobId) continue;
    seen.set(`${documentPackageId}:${blobId}`, { packageId: documentPackageId, blobId });
  }
  return [...seen.entries()];
};

export const DocumentSourcePrefetch: FC<{ chunks: SourceRef[] }> = ({ chunks }) => (
  <>
    {uniqueSources(chunks).map(([key, source]) => (
      <SourceSubscription key={key} {...source} />
    ))}
  </>
);
